import React from 'react';
import { LinkItem } from '../../models/cms';
import { Link } from 'react-router-dom';

interface CustomProps {
  socialMediaData: LinkItem[] | undefined;
}

const SocialMedia = (props: CustomProps) => {
  return (
    <ul className="flex items-center space-x-2">
      {props?.socialMediaData?.map((item) => (
        <li key={item?.id}>
          <a
            href={item?.url || ''}
            target={item?.openInNewTab ? '_blank' : '_self'}
          >
            <div className="flex justify-center items-center">
              <img
                alt={item?.icon?.alternativeText || item?.label || ''}
                src={item?.icon?.url}
              />
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialMedia;
